import React from 'react';

export { AnalysisReportView } from './AnalysisReport';
export { TruncatedText } from './TruncatedText';
export { alert, AlertContainer } from './Alert';
export { Emoji } from './Emoji';
export { FeatureCard, type FeatureItemData } from './FeatureCard';
export {
  DropZone,
  SelectedFilePreview,
  useDropzone,
  type FileWithPath,
} from './DropZone';
export { MarkdownContent } from './MarkdownContent';
export { Note } from './Note';
export { AuthFormNotification } from './AuthFormNotification';
export { Avatar } from './Avatar';
export { Skeleton } from '@aspid/ui';
export { IrrAidaName } from './IrrAidaLogo';
/**
 * Логотип поднят в `@aspid/ui` (AF-580) вместе со своим ассетом.
 *
 * Реэкспорт оставлен, чтобы две точки вызова — `LandingLayout/Header` и
 * `MainLayout/Topbar` — не правились: они берут его из этого барреля.
 */
export { IidfLogo } from '@aspid/ui';
export { Switch } from './Switch';
export { ComponentLoadingFallback } from './ComponentLoadingFallback';

export const FileRenderer = React.lazy(() => import('./FileRenderer'));
